import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'wen-icon-market',
  templateUrl: './market.component.html',
  styleUrls: ['./market.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarketIconComponent {}
